import React from 'react';
import './App.scss';
import { RouterProvider } from "react-router-dom";
import { Router } from './routes/route';

const App: React.FC = () => {
  return (
    <RouterProvider router={Router} />
  );
};

export default App;
